module.exports = __webpack_public_path__ + "media/assets/WarningAlert-c10f9c0465823cb53dd50b2f22e54727.svg";